import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'

import { FormGroup, Label, Input } from 'reactstrap'

import { getFilters } from '../../../redux/plan/actions'

import AccordionItem from '../../../components/Plans/Sidebar/AccordionItem'
import Icon from '../../../components/Icons/Icon'

import FilterIcon from '../../../assets/img/icons/FILTER.svg'

import './PlanFilters.css'

const PlanFilters = () => {
    const [currentFilters, setCurrentFilters] = useState([])

    const onFilterChanged = (filterTitle, item, value) => {
        const currentFilter = currentFilters.find(
            (q) => q.filterTitle == filterTitle
        )
        if (!currentFilter && value) {
            setCurrentFilters([
                ...currentFilters,
                { filterTitle, items: [item] },
            ])
            return
        }

        currentFilter.items = currentFilter.items.filter((q) => q !== item)
        if (value) currentFilter.items.push(item)
        setCurrentFilters([
            ...currentFilters.filter((q) => q.filterTitle !== filterTitle),
            currentFilter,
        ])
    }

    useEffect(() => {
        currentFilters.map((filter) =>
            addQueryString(filter.filterTitle, filter.items.join(','))
        )
    }, [currentFilters])

    const dispatch = useDispatch()
    const filters = useSelector((state) => state.plan.planFilters)
    useEffect(() => {
        dispatch(getFilters())
    }, [])

    const location = useLocation()
    const history = useHistory()

    useEffect(() => {
        const params = new URLSearchParams(location.search)
        const newFilters = []
        for (let param of params) {
            const key = param[0]
            const value = param[1]

            if (new RegExp('[0-9]+').test(key)) {
                newFilters.push({ filterTitle: key, items: value.split(',') })
            }
        }
        setCurrentFilters(newFilters)
    }, [filters])

    const addQueryString = (key, value) => {
        let urlParams = new URLSearchParams(location.search)
        if (!value) urlParams.delete(key)
        else urlParams.set(key, value)
        history.push({ pathname: '/', search: '?' + urlParams.toString() })
    }

    const isChecked = (filterTitle, value) => {
        return currentFilters
            .find((q) => q.filterTitle == filterTitle)
            ?.items.some((q) => q == value)
    }

    return (
        <div className="plan-filters">
            <h3 className="text-right">
                <Icon src={FilterIcon} size="lg" /> فیلترها
            </h3>
            {filters.map((filter, filterIndex) => (
                <AccordionItem
                    key={filterIndex}
                    title={filter.displayTitle}
                    extraInfo={currentFilters
                        .find((q) => q.filterTitle == filter.title)
                        ?.items.map((q) => <span>{q + ' '}</span>)
                        .slice(0, 3)}
                >
                    {filter.items.map((q) => (
                        <FormGroup key={q} check>
                            <Label check>
                                <Input
                                    type="checkbox"
                                    onChange={(e) =>
                                        onFilterChanged(
                                            filter.title,
                                            q,
                                            e.target.checked
                                        )
                                    }
                                    checked={isChecked(filter.title, q)}
                                />{' '}
                                {q}
                            </Label>
                        </FormGroup>
                    ))}
                </AccordionItem>
            ))}
        </div>
    )
}

export default PlanFilters
